import { createFileRoute } from '@tanstack/react-router';

import config from '@@config';
import { requireRoles } from '@@router/guards';

export const Route = createFileRoute('/_authenticated/releasenotes')({
    beforeLoad: requireRoles(config.navigation.releasenotes.authorize),
});
